export default "__VITE_ASSET__c8b08361__"